export { default } from "./TabInfoSection";
